import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-payment-dialog',
    templateUrl: './confirm-payment-dialog.component.html',
    styleUrls: ['./confirm-payment-dialog.component.scss']
})
export class ConfirmPaymentDialogComponent {
    platformFee: number;
    totalAmount: number;
    processing = false;
    selectedCardType: 'credit' | 'debit' = 'credit';

    constructor(
        public dialogRef: MatDialogRef<ConfirmPaymentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.totalAmount = this.data.totalAmount || 0;
        // Platform fee is 0.1% of the total amount
        this.platformFee = Math.round((this.totalAmount * 0.001) * 100) / 100; // Round to 2 decimals
    }

    onCancel() {
        this.dialogRef.close('cancel');
    }

    onPay() {
        this.processing = true;
        // Simulate payment processing
        setTimeout(() => {
            this.processing = false;
            this.dialogRef.close('success');
        }, 1500);
    }
}
